<template>
  <!-- {{ ReservationDetails }} -->
  <body style="font-size: 12pt">
    <div id="page-wrap">
      <div class="row mb-12">
        <div class="col-lg-12">
          <a href="../"></a>
          <img
            style="height: 100px; width: 100px"
            :src="logoUrl"
            :alt="brandName"
          />
        </div>
        <div class="col-lg-12">
          <h6><b>{{ brandName }}</b></h6>
        </div>
        <div class="col-lg-12" v-if="brandTagline">
          <h6>{{ brandTagline }}</h6>
        </div>
        <div class="col-lg-12" v-if="organizationAddress">
          <h6>{{ organizationAddress }}</h6>
        </div>
        <div class="col-lg-12" v-if="organizationPhone">
          <h6>{{ organizationPhone }}</h6>
        </div>
      </div>

      <hr style="border-top: 1px dashed black" />

      <div class="row">
        <div class="col-lg-12">
          <div class="column">
            <div class="row">
              <div class="col-sm-2 textlabel">
                <label for="">Invoice No </label>
              </div>
              <div class="col-sm-5 textlabel">
                <label for="" style="font-weight: bold">
                  {{ ReservationDetails.reference_number }}
                </label>
              </div>
              <div class="col-sm-2 textlabel">
                <label for="">Guest</label>
              </div>
              <div class="col-sm-3 textlabel">
                <label for="" style="font-weight: bold">
                  {{
                    ReservationDetails.guest.name
                      ? ReservationDetails.guest.name
                      : '--'
                  }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2 textlabel">
                <label for="">Date </label>
              </div>
              <div class="col-sm-5 textlabel">
                <label for="" style="font-weight: bold">
                  {{ ReservationDetails.date | formatDate }}
                </label>
              </div>
              <div class="col-sm-2 textlabel">
                <label for="">Phone Number </label>
              </div>
              <div class="col-sm-3 textlabel">
                <label for="" style="font-weight: bold">
                  {{
                    ReservationDetails.guest.phone
                      ? ReservationDetails.guest.phone
                      : '--'
                  }}
                </label>
              </div>
            </div>
            <div class="row">
              <div
                class="col-sm-2 textlabel"
                v-if="ReservationDetails && ReservationDetails.user"
              >
                <label for="">Reserved by </label>
              </div>
              <div class="col-sm-5 textlabel">
                <label for="" style="font-weight: bold">
                  {{ ReservationDetails.user.first_name }}
                </label>
              </div>
              <div class="col-sm-2 textlabel">
                <label for="">Company </label>
              </div>
              <div class="col-sm-3 textlabel">
                <label for="" style="font-weight: bold">
                  {{
                    ReservationDetails.guest.company
                      ? ReservationDetails.guest.company
                      : '--'
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="column">
            <div class="row">
              <div class="col-sm-2 textlabel">
                <label for="">Address</label>
              </div>
              <div class="col-sm-5 textlabel">
                <label for="" style="font-weight: bold">
                  {{
                    ReservationDetails.guest.address
                      ? ReservationDetails.guest.address
                      : '--'
                  }}
                </label>
              </div>
              <div class="col-sm-2 textlabel">
                <label for="">Date Of Birth </label>
              </div>
              <div class="col-sm-2 textlabel">
                <label for="" style="font-weight: bold">
                  {{ ReservationDetails.guest.date_of_birth | formatDate }}
                </label>
              </div>
            </div>
            <div class="row"></div>
          </div>
        </div>
      </div>

      <hr style="border-top: 1px dashed black" />
      <h6 v-if="ReservationDetails.orders.length > 0" style="color: black">
        <p class="text-left mt-6">Foods Order</p>
      </h6>
      <table id="items" v-if="ReservationDetails.orders.length > 0">
        <tr>
          <th style="border: none; border-bottom: 3px solid grey">
            Reference Number
          </th>
          <th style="border: none; border-bottom: 3px solid grey">
            <p class="text-center">Date</p>
          </th>
          <th style="border: none; border-bottom: 3px solid grey">
            <p class="text-left">Item</p>
          </th>
          <th style="border: none; border-bottom: 3px solid grey">Quantity</th>
          <th style="border: none; border-bottom: 3px solid grey">Rate</th>
          <th style="border: none; border-bottom: 3px solid grey">
            <p class="text-right">Amount</p>
          </th>
        </tr>
        <p style="page-break-after: always"></p>
        <tr class="item-row" v-for="(item, index) in ReservationDetails.orders">
          <td class="item-name">
            <div class="delete-wpr">
              {{ item.order_number }}
            </div>
          </td>
          <td class="description">
            {{ item.date | formatDate }}
          </td>
          <td>
            <div v-for="(dishname, index) in item.items">
              <p class="cost text-left" v-if="dishname.dish">
                {{ dishname.dish.name }} ({{ dishname.unit.name }})
              </p>
              <p class="cost text-left" v-else>
                {{ dishname.product.name }}({{ dishname.unit.name }})
              </p>
            </div>
          </td>
          <td>
            <div v-for="(order, index) in item.items">
              <p class="qty">{{ order.quantity ? order.quantity : '' }}</p>
            </div>
          </td>
          <td>
            <div v-for="(order, index) in item.items">
              <p class="qty">{{ order.amount ? order.amount : '' }}</p>
            </div>
          </td>
          <td>
            <div v-for="(order, index) in item.items">
              <p class="qty">
                {{ order.amount ? order.amount * order.quantity : '' }}.00
              </p>
            </div>
          </td>
        </tr>
      </table>
      <p style="page-break-after: auto"></p>

      <hr style="border-top: 1px dashed black" />
      <div class="text-left"><h6>Rooms</h6></div>
      <table id="items">
        <tr>
          <th style="border: none; border-bottom: 3px solid grey">Room</th>
          <th
            style="border: none; border-bottom: 3px solid grey"
            class="text-center"
          >
            Date
          </th>
          <th
            style="border: none; border-bottom: 3px solid grey"
            class="text-right"
          >
            Cost
          </th>
          <th
            style="border: none; border-bottom: 3px solid grey"
            class="text-right"
          >
            Days
          </th>
          <th style="border: none; border-bottom: 3px solid grey">
            <p class="text-right">Price</p>
          </th>
        </tr>
        <tr></tr>
        <tr class="item-row" v-for="(item, index) in ReservationDetails.rooms">
          <td class="item-name">
            <div class="delete-wpr">
              {{ item.room.name }}
            </div>
          </td>
          <td class="description text-right">
            Check In :{{ item.check_in | formatDate }} <br />
            Check Out:{{ item.check_out | formatDate }}
          </td>
          <td class="text-right">{{ item.amount }}</td>
          <td class="text-right">
            {{ item.duration }}
          </td>
          <td>
            <p class="price text-right" style="font-weight: bold">
              {{ item.amount * item.duration }}.00
            </p>
          </td>
        </tr>
      </table>

      <table id="items">
        <!-- <tr>
          <th style="border:none;border-bottom:3px solid grey;">Date</th>
          <th style="border:none;border-bottom:3px solid grey;">Reference Number</th>
          <th style="border:none;border-bottom:3px solid grey;">Payment Type</th>
          <th style="border:none;border-bottom:3px solid grey;">Amount</th>
          <th style="border:none;border-bottom:3px solid grey;">Status</th>
        </tr>
        <tr class="item-row"></tr> -->
        <!-- <tr
          class="item-row"
          v-for="(item, index) in ReservationDetails.payments"
        >
          <td class="item-name">
            <div class="delete-wpr">
              {{ item.date_time | formatDate }}
            </div>
          </td>
          <td class="description">
            {{ item.reference_number ? item.reference_number : "-" }}
          </td>
          <td>
            {{ item.payment_type }}
          </td>
          <td>{{ item.amount }}</td>
          <td>
            <p class="text-right" style="font-weight:bold">{{ item.status }}</p>
          </td>
        </tr> -->

        <p class="text-center"></p>
        <tr>
          <td style="border: none" colspan="2" class="blank"></td>
          <td style="border: none" colspan="2">
            <p class="text-left">Order Total Amount</p>
          </td>
          <td style="border: none">
            <div>
              <p class="text-right" style="font-weight: bold">
                {{ ReservationDetails.order_total_amount }}.00
              </p>
            </div>
          </td>
        </tr>

        <tr>
          <td colspan="2" style="border: none"></td>
          <td colspan="2" style="border: none">
            <p class="text-left">Room Total Amount</p>
          </td>
          <td style="border: none">
            <div>
              <p class="text-right" style="font-weight: bold">
                {{ ReservationDetails.room_total_amount }}.00
              </p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="border: none"></td>
          <td colspan="2" style="border: none">
            <p class="text-left">Total Amount</p>
          </td>
          <td style="border: none">
            <div>
              <p class="text-right" style="font-weight: bold">
                {{ ReservationDetails.total_amount }}.00
              </p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="border: none"></td>
          <td colspan="2" style="border: none">
            <p class="text-left">Amount Paid</p>
          </td>
          <td style="border: none">
            <div>
              <p class="text-right" style="font-weight: bold">
                {{ ReservationDetails.paid_amount }}
              </p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="border: none"></td>
          <td colspan="2" style="border: none">
            <p class="text-left">discount</p>
          </td>
          <td style="border: none">
            <div class="due" style="border: none">
              <p class="text-right" style="font-weight: bold">
                {{
                  ReservationDetails.discount ? ReservationDetails.discount : 0
                }}.00
              </p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="border: none"></td>
          <td colspan="2" style="border: none">
            <p class="text-left">Balance Due</p>
          </td>
          <td style="border: none">
            <div class="due" style="border: none">
              <p class="text-right" style="font-weight: bold">
                {{
                  ReservationDetails.net_amount -
                  ReservationDetails.paid_amount
                }}.00
              </p>
            </div>
          </td>
        </tr>
      </table>

      <hr style="border-top: 1px dashed black" />
      <div>
        <p style="font-weight: bold">Thank You</p>
        <p>Powered by &#169;www.speedcodelabs.com || &#9742; 0212211599</p>
      </div>
      <p style="page-break-after: always"></p>
    </div>
  </body>
</template>
<script>
import axios from '@/plugins/axios';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      ReservationDetails: [],
    };
  },
  computed: {
    ...mapGetters('organization', ['logoUrl', 'brandName', 'brandTagline']),
    ...mapState('organization', ['organization']),
    organizationAddress() {
      return this.organization && this.organization.address;
    },
    organizationPhone() {
      return this.organization && this.organization.phone_number;
    },
  },
  created() {
    this.$store.dispatch('organization/fetchOrganization');
    this.GetReservationDetails();
  },
  methods: {
    print() {
      this.$htmlToPaper('receiptData');
    },
    async GetReservationDetails() {
      let id = this.$route.params.id;
      await axios
        .get(`hms/web/reservations/${id}`)
        .then(res => {
          this.ReservationDetails = res.data;
          this.ReservationDetails.rooms.map(p => {
            let Details = p;
            var a = moment(new Date(p.check_out));
            var b = moment(new Date(p.check_in));
            Details.duration = a.diff(b, 'days');
            // this.ReservationDetails.rooms.push(Details);
          });
        })
        .catch(err => {});
      console.log(
        'Reserr-------------------------------------------',
        this.ReservationDetails,
      );
      setTimeout(function () {
        window.print();
      }, 3000);
    },
  },
};
</script>
<style scoped>
.textlabel {
  text-align: left;
}
.textlabel2 {
  text-align: right;
}
* {
  margin: 0;
  padding: 0;
}
body {
  font: 12px/1.8 'Poppins';
}
#page-wrap {
  width: 900px;
  margin: 0 auto;
}
textarea {
  border: 0;
  font: 14px Georgia, Serif;
  overflow: hidden;
  resize: none;
}
table {
  border-collapse: collapse;
}
table td,
table th {
  border: 1px solid black;
  padding: 5px;
}
#header {
  height: 35px;
  width: 100%;
  margin: 20px 0;
  background: #222;
  text-align: center;
  color: white !important;
  font: bold 18px Helvetica, Sans-Serif;
  text-decoration: uppercase;
  letter-spacing: 20px;
  padding: 8px 0px;
}
#address {
  width: 250px;
  height: 150px;
  float: left;
}
#customer {
  overflow: hidden;
}
#customer-title {
  font-size: 20px;
  font-weight: bold;
  float: left;
}
#meta {
  margin-top: 1px;
  width: 300px;
  float: right;
}
#meta td {
  text-align: right;
}
#meta td.meta-head {
  text-align: left;
  background: #eee;
}
#meta td textarea {
  width: 100%;
  height: 20px;
  text-align: right;
}
#items {
  clear: both;
  width: 100%;
  margin: 30px 0 0 0;
  border: 0px solid black;
}
#items th {
  background: #eee;
}
#items textarea {
  width: 80px;
  height: 50px;
}
#items tr.item-row td {
  border: 0;
  vertical-align: top;
}
#items td.description {
  width: 300px;
}
#items td.item-name {
  width: 175px;
}
#items td.description textarea,
#items td.item-name textarea {
  width: 100%;
}
#items td.total-line {
  border-right: 0;
  text-align: left;
}
#items td.total-value {
  border-left: 0;
  padding: 10px;
}
#items td.total-value textarea {
  height: 20px;
  background: none;
}
#items td.balance {
  background: #eee;
}
#items td.blank {
  border: 0;
}
#terms {
  text-align: center;
  margin: 20px 0 0 0;
}
#terms h5 {
  text-transform: uppercase;
  font: 13px Helvetica, Sans-Serif;
  letter-spacing: 10px;
  border-bottom: 1px solid black;
  padding: 0 0 8px 0;
  margin: 0 0 8px 0;
}
#terms textarea {
  width: 100%;
  text-align: center;
}
#receiptData {
  width: 100%;
  background: white;
}
</style>
